import * as React from 'react';

import { ApplicationContext, AppContext } from '../../context/Contexts';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { AppActionCreators, ApplicationState, AppState } from '../../store';
import { ICaseService } from '../../services/Interfaces/ICaseService';
import { ScaleLoader } from 'react-spinners';
import { Button, Grid, IconButton, List, ListItem } from '@material-ui/core';
import { isNullOrUndefined } from 'util';
import { withRouter } from 'react-router';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { NotificationProps, UserNotificationProps } from '../../interfaces/Case';
import { UserNotification } from '../../interfaces/UserNotificationsUpdate';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAppointmentNewInNotificationState {}

class AppointmentNewInNotificationItem extends React.PureComponent<
  UserNotificationProps,
  IAppointmentNewInNotificationState
> {
  private caseService!: ICaseService;

  static contextType = ApplicationContext;

  state = {} as IAppointmentNewInNotificationState;

  onClick = async (notificationId: number, appointmentId: number) => {
    try {
      await this.caseService.ReadUserNotification(notificationId);

      this.props.MarkAsViewedNotification(notificationId);

      const currentPath = this.props.history.location.pathname.toLowerCase();
      this.props.history.push('/appointment/' + appointmentId);

      if (currentPath.indexOf('/appointment/') !== -1) {
        this.props.history.go(0);
      }

      if (this.props.onClick !== undefined) {
        this.props.onClick();
      }
    } catch (err) {
      console.log(err);
    }
  };

  deleteItem = async (notificationId: number) => {
    try {
      await this.caseService.DeleteUserNotification(notificationId);

      this.props.RemoveNotification(notificationId);
    } catch (err) {
      console.log(err);
    }
  };

  public render() {
    this.caseService = (this.context as AppContext).caseService;
    const item = this.props.item.entity as UserNotification;
    const index = this.props.index;
    const isInPopup = this.props.item.isInPopup;

    return (
      <React.Fragment>
        <Grid container spacing={1}>
            <Grid item xs={1}>
            <div
                className={`p-0 ${!item.read ? 'font-weight-bold' : ''}`}
            >
                {index + 1}
            </div>
            </Grid>
            <Grid item xs={3}>
            <div
                className={`text-primary p-0 ${!item.read ? 'font-weight-bold' : ''}`}
                onClick={(e) => this.onClick(item.id, item.entityId)}
                style={{ cursor: 'pointer' }}
            >
                {item.entityId}
            </div>
            <div className={`${!item.read ? 'font-weight-bold' : ''}`}>
                {item.details.statusDisplayName}
                {isInPopup && (
                    <FontAwesomeIcon 
                    icon={['far', 'folder-open']}
                    style={{ width: 20, height: 20, marginLeft : '10px'}}
                    className="align-self-center display-1"
                    />
                )}
            </div>
            </Grid>

            <Grid item xs={4}>
            <div className={`${!item.read ? 'font-weight-bold' : ''}`}>
                {item.details.categoryDisplayName}
            </div>
            <div className="font-size-sm text-black-50">
                {isNullOrUndefined(item.details.vehiclePlateNumber) ? '' : item.details.vehiclePlateNumber}
            </div>
            </Grid>
            <Grid item xs={3}>
            <div className="font-size-sm text-black-50">
                {moment
                .utc(item.details.statusDate)
                .local()
                .format(this.props.appState.longDateFormat)}
            </div>
            </Grid>
            <Grid item container direction="column" xs={1}>
            <IconButton
                aria-label="delete"
                color="inherit"
                className="text-danger"
                size="small"
                onClick={(e) => {
                this.deleteItem(item.id);
                }}
            >
                <DeleteOutlineTwoToneIcon />
            </IconButton>
            </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const mergeProps = (
  stateProps: any,
  dispatchProps: any,
  ownProps: NotificationProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});

export default connect(
  (state: ApplicationState) => ({
    caseSettingsState: state.caseSettings,
    appState: state.app
  }),
  AppActionCreators,
  mergeProps
)(withRouter(AppointmentNewInNotificationItem as any));
